/** Digits-only CNPJ (14) for storage / Stripe id_numbers. */
export function normalizeCnpjDigits(cnpj?: string | null): string | null {
  if (!cnpj?.trim()) return null;
  const digits = cnpj.replace(/\D/g, '').slice(0, 14);
  return digits.length === 14 ? digits : null;
}
